import { Euler, Vector3 } from 'three';
import { TransformationDataDTO } from '../DTOs/TransformationDataDTO';

export class TransformationData {
  public static getEmptyTransformationData() {
    return new TransformationData(undefined, [0, 0, 0], [0, 0, 0]);
  }

  public static fromDTO(transformationDataDTO: TransformationDataDTO) {
    return new TransformationData(
      transformationDataDTO.id?.toString(),
      transformationDataDTO.position,
      transformationDataDTO.rotation,
    );
  }

  id: string | undefined;
  position: Vector3;
  rotation: Euler;

  constructor(id: string | undefined, position: number[], rotation: number[]) {
    this.id = id;
    this.position = new Vector3(position[0], position[1], position[2]);
    this.rotation = new Euler(rotation[0], rotation[1], rotation[2]);
  }

  public toDTO(): TransformationDataDTO {
    return new TransformationDataDTO(
      Number(this.id) || undefined,
      [this.position.x, this.position.y, this.position.z],
      [this.rotation.x, this.rotation.y, this.rotation.z],
    );
  }
}
